import { useState, useEffect, useContext } from 'react';
import { AppBar, Toolbar, IconButton, Typography, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { IoMdArrowBack } from 'react-icons/io';
import { toast } from 'react-toastify';
import { AuthContext } from '../Context/AuthContext';

const SettingsPage = () => {
  const [appVersion, setAppVersion] = useState('');
  const navigate = useNavigate();
    const { isAuthenticated, setIsAuthenticated, setUser, setToken } = useContext(AuthContext);
  
  useEffect(() => {
    // Mock the app version retrieval logic
    const getAppVersion = async () => {
      try {
        const version = '1.0.0'; // Replace this with actual version retrieval logic
        setAppVersion(version);
      } catch (error) {
        console.error('Error fetching app version:', error);
      }
    };

    getAppVersion();

    const checkAuthentication = async () => {
      try {
        if (!isAuthenticated) {
          navigate('/login');
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
        navigate('/login');
      }
    };

    checkAuthentication();
  }, [navigate, isAuthenticated]);

  const goto = (path) => {
    navigate(`/${path}`);
  };

  const logout = async () => {
    await axios
    .get(import.meta.env.VITE_APP_BASE_API + import.meta.env.VITE_APP_API_VERSION + "/user/patient/logout", {
      withCredentials: true,
    })
    .then((res) => {
      toast.success(res.data.message);
      setIsAuthenticated(false);
      setUser({});
      setToken(null);
      localStorage.removeItem("token");
      localStorage.removeItem('senseData');
      localStorage.removeItem('painData');
      navigate('/login');
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
  };

  return (
    <div>
      <AppBar position="static">
        <Toolbar>
        <Link to={"/profile"}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="back"
              sx={{ mr: 2 }}
            >
              <IoMdArrowBack />
            </IconButton>
          </Link>
          <Typography variant="h6">
            Settings
          </Typography>
        </Toolbar>
      </AppBar>
      <div className="p-4">
        <div className="flex flex-col items-center">
          <img src="/imgs/icon.png" alt="Logo" className="w-20 h-20" />
          <Typography variant="h5" className="mt-2">SmartNurse</Typography>
          <Typography variant="body2" className="mt-1">v.{appVersion}</Typography>
        </div>
        <List className="mt-4">
          <ListItem onClick={() => goto('hippa-compliance')}>
            <ListItemText primary="Hippa compliant data" />
            <ListItemIcon>
              <ArrowForwardIosIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem onClick={() => goto('how')}>
            <ListItemText primary="How it Works" />
            <ListItemIcon>
              <ArrowForwardIosIcon />
            </ListItemIcon> 
          </ListItem>
          <ListItem onClick={() => goto('faq')}>
            <ListItemText primary="FAQ" />
            <ListItemIcon>
              <ArrowForwardIosIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem onClick={() => goto('privacy')}>
            <ListItemText primary="Privacy policy" />
            <ListItemIcon>
              <ArrowForwardIosIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem onClick={() => goto('terms')}>
            <ListItemText primary="Terms & Conditions" />
            <ListItemIcon>
              <ArrowForwardIosIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem onClick={logout}>
            <ListItemText primary="Logout" />
            <ListItemIcon>
              <ArrowForwardIosIcon />
            </ListItemIcon>
          </ListItem>
        </List>
      </div>
    </div>
  );
};

export default SettingsPage;
